import PropTypes from 'prop-types'
import {
  Table, Button, Tag, Popconfirm,
} from 'antd'
import { EditTwoTone, DeleteTwoTone, PlusOutlined } from '@ant-design/icons'
import history from 'utils/history'

const SocialMedia = ({
  data, isLoading, handleDelete,
}) => {
  const columns = [
    {
      title: 'No',
      dataIndex: '',
      key: 'No',
      width: 80,
      render: (text, record, index) => (data.meta.limit * (data.meta.page - 1)) + index + 1,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: text => text || '-',
    },
    {
      title: 'Slug',
      dataIndex: 'slug',
      key: 'slug',
      render: text => text || '-',
    },
    {
      title: 'URL',
      dataIndex: 'url',
      key: 'url',
      render: text => text || '-',
    },
    {
      title: 'Logo',
      dataIndex: 'logo_path',
      key: 'logo_path',
      render: text => text || '-',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: text => <Tag color={text === 'active' ? 'green' : 'red'}>{text}</Tag>,
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'action',
      width: 80,
      render: (text, record) => (
        <div className="d-flex justify-content-center">
          <EditTwoTone twoToneColor="#faad14" className="mr-2" onClick={() => history.push(`/social-media/${record.id}/edit`)} />
          <Popconfirm
            title="Are you sure delete this Category?"
            okText="Yes"
            cancelText="No"
            placement="topLeft"
            onConfirm={() => handleDelete(record.id)}
          >
            <DeleteTwoTone twoToneColor="#ff4d4f" />
          </Popconfirm>
        </div>
      ),
    },
  ]

  return (
    <div>
      <div className="pb-3">
        <div className="btn-primary-wrapper d-flex justify-content-between mb-4">
          <h3 className="title-content mb-0">List Social Media</h3>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => history.push('/social-media/add')}>
            Add Social Media
          </Button>
        </div>
      </div>
      <Table
        rowKey="id"
        className="table-striped-rows"
        columns={columns}
        dataSource={data.list}
        loading={isLoading}
        pagination={false}
      />
    </div>
  )
}

SocialMedia.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  handleDelete: PropTypes.func,
}

export default SocialMedia
